// 引用api文件
import api from '../index';
/* *** 注释信息 @author Zhou @date 2020/2/21 *** */
/* 登录管理
/* ******************************************** */
// 登录
export function LoginIn(data, success, failure, menuId) { return api.post('zuul-login/zuul/hzf-admin/dologin', data, success, failure, menuId); }
// 获取验证码
export function GetCode(data, success, failure, menuId) { return api.post('zuul-login/zuul/common/imageCodeInfo', data, success, failure, menuId); }
//置换token
export function GetToken(data, success, failure, menuId) { return api.post('hzf-admin/sys/userInfo/tokenUpdate', data, success, failure, menuId); }
